import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const TITLES: Record<string, string> = {
  en: "✨ AI Features Restored!",
  es: "✨ ¡Funciones de IA restauradas!",
  de: "✨ KI-Funktionen wiederhergestellt!",
};

const MESSAGES: Record<string, string> = {
  en: "GlucoPhoto and Recipe Creator are back online and ready to use.",
  es: "GlucoPhoto y el Creador de Recetas están de vuelta y listos para usar.",
  de: "GlucoPhoto und der Rezeptersteller sind wieder online und einsatzbereit.",
};

const BUTTON_LABELS: Record<string, string> = {
  en: "Got it!",
  es: "¡Entendido!",
  de: "Verstanden!",
};

export default function AiRestoredModal({ open, onOpenChange }: Props) {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const title = TITLES[lang] || TITLES.en;
  const message = MESSAGES[lang] || MESSAGES.en;
  const buttonLabel = BUTTON_LABELS[lang] || BUTTON_LABELS.en;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-2xl p-6 text-center border-border/60 bg-card">
        <DialogHeader className="items-center">
          <div className="w-14 h-14 rounded-full bg-green-100 dark:bg-green-950/30 flex items-center justify-center mb-1">
            <Sparkles size={28} className="text-green-600 dark:text-green-400" />
          </div>
          <DialogTitle className="text-lg font-extrabold text-center text-foreground">
            {title}
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground mt-1 mb-5">
          {message}
        </p>

        <button
          onClick={() => onOpenChange(false)}
          className="w-full py-3 rounded-xl bg-primary text-primary-foreground font-bold text-sm active:scale-[0.97] transition-transform"
        >
          {buttonLabel}
        </button>
      </DialogContent>
    </Dialog>
  );
}
